import {
    call, put, takeEvery, all,
} from 'redux-saga/effects';
import { INVITE_USER_DATA_REQUEST } from '../constants/invite_user_data.constants';
import {
    inviteUserDepartment, inviteUserGender, inviteUserNamePrefixes, inviteUserRoles,
} from '../../../User_profile/requests/user_profile_requests/invite_user_data_request';
import { inviteUserDataRequestSuccess, inviteUserDataRequestFailure } from '../actions/invite_user_data.actions';

function* inviteUserDataRequest() {
    const [departments, gender, prefixes, roles, error] = yield all([
        call(inviteUserDepartment),
        call(inviteUserGender),
        call(inviteUserNamePrefixes),
        call(inviteUserRoles),
    ]);
    departments && gender && prefixes && roles
        ? yield put(inviteUserDataRequestSuccess({
            departments, gender, prefixes, roles,
        }))
        : yield put(inviteUserDataRequestFailure(error));
}

export default function* inviteUserDataSaga() {
    yield takeEvery(INVITE_USER_DATA_REQUEST, inviteUserDataRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/sagas/invite_user_data.saga.js